module.exports = __webpack_public_path__ + "caracol-large.jpg?fce0317253c848338abfa98e3d71d608";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/caracol-large.jpg
// module id = 169
// module chunks = 0